<template>
<div>
  <!--管家app菜单-->
  <x-application></x-application>
</div>
</template>

<script>
export default {
  name: 'stewardApp'
};
</script>

<style scoped>

</style>
